import React, { Component } from 'react';
import { object } from 'prop-types';
import { Table } from '../../common';

export default class CallHistoryTable extends Component {
    static propTypes = {
        data: object,
        columns: object
    }

    render () {
        const { data, columns } = this.props;
        return <Table data={data} columns={columns} />;
    }
}
